export const MuiMenu = {
    styleOverrides: {
        paper: {
            borderRadius: "4px"
        }
    }
};
//# sourceMappingURL=Menu.js.map